import Colors from 'assets/Colors';
import FirebaseService from 'common/services/FirebaseService';
import { isFinite } from 'lodash';
import { Dimensions, Keyboard, Linking, Platform } from 'react-native';
import Configs from 'utils/Configs';

const log = (() => {
  if (!__DEV__) return () => {};
  return Function.prototype.bind.call(console.log, console, '## LOG: ');
})();

function hideKeyboard() {
  Keyboard.dismiss();
}

function openStore(url = 'https://google.com') {
  Linking.openURL(url);
}

async function checkPermission(permisison, showSetting = true) {
  return true;
}

function jsonEscape(str) {
  return str
    .replace(/\n/g, '\\\\n')
    .replace(/\r/g, '\\\\r')
    .replace(/\t/g, '\\\\t');
}

function formatNumber(num, char = ',', forceOdd = false) {
  if (!num) return '0';
  try {
    if (num > 1 && num.toString()[0] === '0') num = num.toString().slice(1);
    if (!forceOdd && !Configs.settings.showOdd) {
      num = Math.round(num);
    } else if (
      num
        .toString()
        .split('')
        .reverse()
        .join('')
        .indexOf('.') > 2
    ) {
      // Tofixed number than 2 number after .
      num = parseFloat(num).toFixed(2);
    }
    if (!isFinite(parseFloat(num)) || isNaN(num)) num = 0;
    let numStr = num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${char}`);
    if (numStr.indexOf('.00') === numStr.length - 3) numStr = numStr.replace('.00', '');
    return numStr;
  } catch (err) {
    console.log('ERROR', err);
    FirebaseService.logError(err);
  }
  return '0';
}

function formatLargeNumber(num, digits = 1) {
  const lookup = [
    { value: 1, symbol: '' },
    { value: 1e3, symbol: 'k' },
    { value: 1e6, symbol: 'M' },
    { value: 1e9, symbol: 'G' },
    { value: 1e12, symbol: 'T' },
    { value: 1e15, symbol: 'P' },
    { value: 1e18, symbol: 'E' }
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var item = lookup
    .slice()
    .reverse()
    .find((e) => {
      return num >= e.value;
    });
  return item ? (num / item.value).toFixed(digits).replace(rx, '$1') + item.symbol : '0';
}

function formatCurency(num) {
  if (Configs.language === 'en') return Configs.currency + formatNumber(num);
  return formatNumber(num) + Configs.currency;
}

function checkStringEmpty(string) {
  return /^ *$/.test(string);
}

function delay(time) {
  var promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      try {
        resolve();
      } catch (err) {
        reject({
          error: err
        });
      }
    }, time);
  });
  return promise;
}

function isIphoneX() {
  const dimen = Dimensions.get('window');
  return Platform.OS === 'ios' && !Platform.isPad && !Platform.isTVOS && (dimen.height === 812 || dimen.width === 812 || dimen.height === 896 || dimen.width === 896);
}

function getPaddingBottom() {
  return isIphoneX() ? 20 : 0;
}

function getPaddingTop() {
  return isIphoneX() ? 50 : 24;
}

function random(from, to) {
  var add = from === 0 || to === 0 ? 1 : 0;
  return Math.floor(Math.random() * (to + add) + from);
}

function randomColor(numOfSteps, step) {
  var color = '#' + ((Math.random() * 0xffffff) << 0).toString(16);
  return color;
}

function compareObject(objA, objB) {
  if ((objA === null && objB != null) || (objB === null && objA != null)) return false;
  var aProps = Object.getOwnPropertyNames(objA);
  var bProps = Object.getOwnPropertyNames(objB);
  if (aProps.length !== bProps.length) {
    return false;
  }
  for (var i = 0; i < aProps.length; i++) {
    var propName = aProps[i];
    if (objA[propName] !== objB[propName]) {
      return false;
    }
  }
  return true;
}

function jsonParse(str) {
  try {
    if (typeof str === 'object') return str;
    str = JSON.parse(str);
    if (typeof str === 'string') return jsonParse(str);
    return str;
  } catch (err) {
    log('ERROR', err, str);
  }
  return null;
}

export default {
  log,
  delay,
  random,
  randomColor,
  hideKeyboard,
  jsonEscape,
  openStore,
  formatLargeNumber,
  convertNumber: (str) => {
    try {
      let num = parseFloat(
        str
          ?.toString()
          .split(',')
          .join('')
      ).toFixed(2);
      num = parseFloat(num);
      if (!Configs.settings.showOdd) num = Math.round(num);
      if (!isFinite(num) || isNaN(num)) num = 0;
      return num;
    } catch (err) {
      console.log('ERROR', err);
    }
    return 0;
  },
  formatNumber,
  formatFloatNumber: (number) => {
    try {
      let value = parseFloat(number).toFixed(2);
      const arr = value.split('.');
      if (arr.length > 1 && parseFloat(arr[1]) === 0) value = arr[0];
      return formatNumber(value, ',', true);
    } catch (err) {
      console.log('ERROR', err);
      return 0;
    }
  },
  formatCurency,
  checkStringEmpty,
  getPaddingBottom,
  getPaddingTop,
  compareObject,
  checkPermission,
  jsonParse,
  getDebtColor: (money) => {
    if (!Configs.settings.showOdd) {
      money = Math.round(money);
    }
    if (money === 0) return Colors.text;
    return money >= 0 ? 'red' : Colors.colorApp;
  },
  validateIP4: (ip) => {
    var arrIp = ip.split('.');
    if (arrIp.length !== 4) return false;
    for (let oct of arrIp) {
      if (isNaN(oct) || Number(oct) < 0 || Number(oct) > 255) return false;
    }
    return true;
  },
  waitFunc: async (time, func: () => {}) => {
    var promise = new Promise(async (resolve, reject) => {
      let finish = false;
      setTimeout(() => {
        if (finish) return;
        finish = true;
        resolve({ status: 0 });
      }, time);
      await func();
      if (finish) return;
      finish = true;
      resolve({ status: 1 });
    });
    return promise;
  },

  isDeviceOrientationLandscape: async () => {
    return false;
  },

  isNumber(num) {
    return !(isNaN(num) || num === null);
  },

  convertNumberToVietnameseText(numberInput) {
    if (isNaN(numberInput)) return 'Không phải số hợp lệ';
    const chuSo = ['không', 'một', 'hai', 'ba', 'bốn', 'năm', 'sáu', 'bảy', 'tám', 'chín'];
    const donVi = ['', 'nghìn', 'triệu', 'tỷ', 'nghìn tỷ', 'triệu tỷ'];
    numberInput = parseFloat(numberInput).toFixed(2); // Làm tròn đến 2 chữ số thập phân
    let [nguyen, le] = numberInput.toString().split('.');
    let number = parseInt(nguyen);

    function docBaSo(num) {
      let tram = Math.floor(num / 100);
      let chuc = Math.floor((num % 100) / 10);
      let donvi = num % 10;
      let result = '';
      if (tram > 0) {
        result += chuSo[tram] + ' trăm';
        if (chuc === 0 && donvi > 0) result += ' linh';
      }
      if (chuc > 0) {
        if (chuc === 1) result += ' mười';
        else result += ' ' + chuSo[chuc] + ' mươi';
      }
      if (donvi > 0) {
        if (chuc > 0) {
          if (donvi === 1) result += ' mốt';
          else if (donvi === 5) result += ' lăm';
          else result += ' ' + chuSo[donvi];
        } else {
          result += ' ' + chuSo[donvi];
        }
      }
      return result.trim();
    }
    let text = '';
    let i = 0;
    while (number > 0) {
      let baSo = number % 1000;
      if (baSo !== 0) {
        let prefix = docBaSo(baSo);
        if (donVi[i]) prefix += ' ' + donVi[i];
        text = prefix + (text ? ' ' + text : '');
      }
      number = Math.floor(number / 1000);
      i++;
    }
    if (!text) text = 'Không';
    text = text.charAt(0).toUpperCase() + text.slice(1);

    // Xử lý phần lẻ sau dấu phẩy (đã làm tròn 2 số)
    if (le && parseInt(le) !== 0) {
      const leSo = parseInt(le);
      let leText = '';
      if (leSo < 10) {
        leText = chuSo[leSo];
      } else {
        leText = docBaSo(leSo);
      }
      text += ' phẩy ' + leText;
    }
    text += ' đồng';
    return text;
  },

  compareVersion(v1, v2) {
    const a1 = v1.split('.').map(Number);
    const a2 = v2.split('.').map(Number);
    const len = Math.max(a1.length, a2.length);

    for (let i = 0; i < len; i++) {
      const n1 = a1[i] || 0;
      const n2 = a2[i] || 0;

      if (n1 > n2) return 1; // v1 > v2
      if (n1 < n2) return -1; // v1 < v2
    }
    return 0;
  }
};
